var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hom-pro-list warp", class: "terminal" + _vm.terminal },
    [
      _c(
        "div",
        {
          staticClass: "title",
          class: "text-align-" + _vm.componentContent.textAlign
        },
        [
          _c("h2", { staticClass: "h2" }, [
            _vm._v(_vm._s(_vm.componentContent.title))
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn-all a-link",
              on: {
                click: function($event) {
                  return _vm.jumpDiscount(
                    _vm.shopId !== 0 && {
                      shopId: _vm.shopId,
                      id: _vm.componentContent.shopDiscountId
                    }
                  )
                }
              }
            },
            [
              _vm._v("查看全部"),
              _c("i", { staticClass: "iconfont icon-arrow-right" })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.componentContent.labelShow,
                  expression: "componentContent.labelShow"
                }
              ],
              staticClass: "tabList"
            },
            [
              _c(
                "ul",
                _vm._l(_vm.componentContent.labelList, function(item, index) {
                  return _c(
                    "li",
                    { key: index },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: _vm.jumpLink(item.linkObj) } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    ],
                    1
                  )
                }),
                0
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.componentContent.shopDiscountId ||
      _vm.componentContent.productData.productIdList.length != 0
        ? _c("div", [
            _vm.terminal === 4
              ? _c(
                  "div",
                  {
                    staticClass: "discountList",
                    class: this.typeId === 1 && "pc"
                  },
                  [
                    _vm.discountInfo.products &&
                    _vm.discountInfo.products.length > 0
                      ? _c("div", { staticClass: "listLeft" }, [
                          _c("img", {
                            attrs: {
                              src: require("../static/images/shop/xianshi@2x.png"),
                              alt: ""
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "bgBox" }, [
                            _c("div", { staticClass: "endTime" }, [
                              _vm._v(_vm._s(_vm.discountInfo.discountName))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "line" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "endTimeText" }, [
                              _vm._v("距离" + _vm._s(_vm.count[0]) + "还剩")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "timeBox" }, [
                              _c("span", [_vm._v(_vm._s(_vm.count[1]))]),
                              _c("i", [_vm._v(":")]),
                              _c("span", [_vm._v(_vm._s(_vm.count[2]))]),
                              _c("i", [_vm._v(":")]),
                              _c("span", [_vm._v(_vm._s(_vm.count[3]))])
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.jumpDiscount(
                                      _vm.shopId !== 0 && {
                                        shopId: _vm.shopId,
                                        id: _vm.componentContent.shopDiscountId
                                      }
                                    )
                                  }
                                }
                              },
                              [_vm._v("查看全部>")]
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "listRight" },
                      _vm._l(_vm.discountInfo.products, function(it) {
                        return _c(
                          "div",
                          {
                            key: it.productId,
                            staticClass: "listItem",
                            on: {
                              click: function($event) {
                                return _vm.jumpProductDetail(it)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "imgBox" }, [
                              _c("img", { attrs: { src: it.image, alt: "" } })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "itemInfo" }, [
                              _c("h3", [_vm._v(_vm._s(it.productName))]),
                              _vm._v(" "),
                              _c("div", { staticClass: "discountPrice" }, [
                                _c("span", [_vm._v("折扣价￥")]),
                                _c("b", [_vm._v(_vm._s(it.price))])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "originalPrice" }, [
                                _vm._v("原价：¥" + _vm._s(it.originalPrice))
                              ]),
                              _vm._v(" "),
                              _c("button", [_vm._v("立即抢购")])
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  ]
                )
              : _c("div", { staticClass: "mobileList" }, [
                  _c(
                    "div",
                    {
                      staticClass: "topList mItem",
                      on: {
                        click: function($event) {
                          return _vm.jumpProductDetail(_vm.firstProduct)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "topImgBg" }, [
                        _c("img", {
                          attrs: { src: _vm.firstProduct.image, alt: "" }
                        }),
                        _vm._v(" "),
                        _vm._m(0),
                        _vm._v(" "),
                        _c("div", { staticClass: "rightDateBox" }, [
                          _vm.count && _vm.count.length > 0
                            ? _c("span", [
                                _vm._v(
                                  "距" +
                                    _vm._s(_vm.count[0]) +
                                    "还有 " +
                                    _vm._s(
                                      _vm.count[1] +
                                        ":" +
                                        _vm.count[2] +
                                        ":" +
                                        _vm.count[3]
                                    )
                                )
                              ])
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "itemInfo" }, [
                        _c("div", { staticClass: "itemTit" }, [
                          _c("h3", [
                            _vm._v(_vm._s(_vm.firstProduct.productName))
                          ]),
                          _vm._v(" "),
                          _vm.firstProduct.limitNumber &&
                          _vm.firstProduct.limitNumber > 0
                            ? _c("span", [
                                _vm._v(
                                  "剩余" +
                                    _vm._s(_vm.firstProduct.stockNumber) +
                                    "件"
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "Price" }, [
                          _c("span", [
                            _c("b", [_vm._v("￥")]),
                            _vm._v(_vm._s(_vm.firstProduct.price))
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "¥ " + _vm._s(_vm.firstProduct.originalPrice)
                            )
                          ])
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "listBox" },
                    [
                      _vm._l(_vm.appProducts, function(it) {
                        return _c(
                          "div",
                          {
                            key: it.productId,
                            staticClass: "mItem",
                            on: {
                              click: function($event) {
                                return _vm.jumpProductDetail(it)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "topImgBg" }, [
                              _c("img", { attrs: { src: it.image, alt: "" } }),
                              _vm._v(" "),
                              _vm._m(1, true),
                              _vm._v(" "),
                              _c("div", { staticClass: "rightDateBox" }, [
                                _vm.count && _vm.count.length > 0
                                  ? _c("span", [
                                      _vm._v(
                                        "距" +
                                          _vm._s(_vm.count[0]) +
                                          " " +
                                          _vm._s(
                                            _vm.count[1] +
                                              ":" +
                                              _vm.count[2] +
                                              ":" +
                                              _vm.count[3]
                                          )
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "itemInfo" }, [
                              _c("div", { staticClass: "itemTit" }, [
                                _c("h3", [
                                  _vm._v(_vm._s(_vm.firstProduct.productName))
                                ])
                              ]),
                              _vm._v(" "),
                              it.limitNumber && it.limitNumber > 0
                                ? _c("div", { staticClass: "surplus" }, [
                                    _vm._v(
                                      "剩余" + _vm._s(it.stockNumber) + "件"
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "Price" }, [
                                _c("span", [
                                  _c("b", [_vm._v("￥")]),
                                  _vm._v(_vm._s(it.price))
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v("¥ " + _vm._s(it.originalPrice))
                                ])
                              ])
                            ])
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ],
                    2
                  )
                ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "leftText" }, [
      _c("i", { staticClass: "iconfont" }, [_vm._v("")]),
      _vm._v(" "),
      _c("span", [_vm._v("限时折扣")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "leftText" }, [
      _c("span", [_vm._v("限时折扣")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-68d2c982", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-68d2c982","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/canvasShow/basics/discountList.vue
// module id = null
// module chunks = 